import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function formLogin(username, password, code) {
  return dispatchCommand("FormLogin", {
    username: username,
    password: password,
    code: code
  });
}
